<template>
  <div class="request-form">
    <h3 class="request-form__title">Записаться на проект</h3>
    <p class="request-form__text">Просто заполните форму ниже, мы перезвоним</p>
    <div class="request-form__inner">
      <AppInput
        v-model="form.name"
        placeholder="Имя"
        required
        :error="validationErrors.name"
      />
      <AppInput
        v-model="form.phone"
        placeholder="Телефон"
        required
        :error="validationErrors.phone"
      />
      
      <label class="request-form__agreement" style="display: flex; align-items: flex-start; gap: 8px; cursor: pointer;">
        <input type="checkbox" v-model="agreement" style="margin-top: 4px; cursor: pointer; width: 16px; height: 16px; flex-shrink: 0;" />
        <span class="request-form__annotation" style="user-select: none;">
          Я ознакомился и согласен с <router-link to="/privacy-policy" target="_blank" style="text-decoration: underline; color: inherit;">Политикой конфиденциальности</router-link>, а также даю согласие на обработку персональных данных
        </span>
      </label>

      <AppButton theme="dark" @click="submitRequest" :disabled="!agreement">
        Отправить заявку
      </AppButton>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, ref } from 'vue'

import AppButton from '@/components/ui/AppButton/Index.vue'
import AppInput from '@/components/ui/AppInput/Index.vue'

import MailService from '@/services/MailService/Index'
import { IMailPayload } from '@/services/MailService/types'
import { AxiosError } from 'axios'

export default defineComponent({
  name: 'AppRequestForm',
  components: { AppButton, AppInput },
  setup() {
    const form = reactive<IMailPayload>({
      name: '',
      phone: '',
    })
    const validationErrors = ref<Record<string, any>>({})
    const agreement = ref(false)

    const submitRequest = async () => {
      if (!agreement.value) return

      try {
        await MailService.sendRequest(form)

        form.name = ''
        form.phone = ''
        agreement.value = false
        validationErrors.value = {}
      } catch (e) {
        const { response } = e as AxiosError<{ detail: Record<string, any> }>

        if (!response) return

        validationErrors.value = response.data.detail
      }
    }

    return { form, validationErrors, agreement, submitRequest }
  },
})
</script>

<style lang="scss" scoped src="./Index.scss" />